<div class="business-manager">
    <key-value-pair-list [keyValuePairs]="keyValuePairs()"></key-value-pair-list>
</div>
